import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import {
  CreateRefundDeliveryStatusCommand,
  DeliveryStatus,
  UpdateRefundDeliveryStatusCommand,
} from 'src/app/core/api/models';
import { RefundDeliveryStatusesService } from 'src/app/core/api/services';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { DialogService } from 'src/app/core/services/dialog.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-refund-delivery-status-form',
    templateUrl: './refund-delivery-status-form.component.html',
    imports: [BaseFormModule]
})
export class RefundDeliveryStatusFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  model: CreateRefundDeliveryStatusCommand = {};
  formPageConfig: FormPageConfig<any> = {};
  protected currentService = inject(RefundDeliveryStatusesService);  

  get DeliveryStatus() {
    return DeliveryStatus;
  }
  //#endregion

  constructor(
    public dialogService: DialogService,
    public translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.changeValidation();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      deliveryStatuses: new FormControl(''),
    });
  }

  changeValidation() {
    if (this.formPageConfig.isEditMode) {
      this.form.get('title').disable();
    }
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateRefundDeliveryStatusCommand) {
    this.loading = true;

    this.currentService
      .refundDeliveryStatusesCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateRefundDeliveryStatusCommand) {
    this.unSubs();
    this.loading = true;
    model.id = this.formPageConfig.editId;

    this.currentService
      .refundDeliveryStatusesUpdate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
}
